/**
 * The list view: the same documents as the grid, in the suite's standard table.
 *
 * PlatformTable, NOT A BESPOKE TABLE. It brings sorting, column selection, paging, the Refresh menu
 * and the empty state that every other list in the suite has, and a hand-rolled table here would be
 * a second thing to keep in step with all of them.
 *
 * THE ROWS COME FROM THE PAGE, so the grid and the list show the same documents -- including when a
 * search has narrowed them. The component is fed rather than fetching; see
 * DocumentEnterpriseComponent for why.
 *
 * THE ROW MENU AND CLICK-TO-OPEN LIVE IN THE CELLS, in DocumentsTable: the base table builds each
 * column's renderer from a NAME it looks up, so a control in a row has to be a named cell renderer
 * on a subclass. This component only hands the page's callbacks down, so a card and a row do the
 * same thing on the same action.
 */
import React, { useEffect, useState } from "react";

import DocumentTableApplet from "../../eoec/applet/impl/Docs/DocumentTableApplet";
import { makeEnterpriseComponent } from "../../util/utility";
import { DocumentRow } from "./DocumentCard";
import { SortKey } from "../../util/documentFilters";

export default function DocumentTable({ rows, busy, onOpen, onAction, onRefresh, onSort }: {
    rows: DocumentRow[];
    busy?: string | null;
    onOpen: (revisionUSID: string) => void;
    onAction: (revisionUSID: string, action: string) => void;
    onRefresh: () => void;
    /** The order the table's own menu chose, so the cards can be drawn in it too. */
    onSort?: (sort: { key: SortKey; descending: boolean } | null) => void;
}) {
    // ONE COMPONENT FOR THE LIFE OF THE TABLE. Rebuilding it would re-run the mount query and
    // reset paging and sort under the reader's hands on every parent render.
    const [component] = useState<any>(() => makeEnterpriseComponent("Document"));

    useEffect(() => { component.setRows(rows); }, [component, rows]);

    // ASSIGNED RATHER THAN PASSED AS A PROP, because the component outlives every render and the
    // thing that learns about a sort is the component, not this element. See its setSortSpecification.
    useEffect(() => { component.onSort = onSort; }, [component, onSort]);

    return <DocumentTableApplet enterpriseComponent={component}
                                onOpen={onOpen} onAction={onAction} busy={busy}
                                onRefresh={onRefresh} />;
}
